import type {OnlinePlayer} from '../net/online';
import {region} from '../../../shared/regions.mjs';
import {nearTownService} from './worldServices';
export function borderTravelReason(p:OnlinePlayer|undefined,city:string):string|undefined{
 if(!p||!p.profile?.created)return 'เข้าเล่นและสร้างตัวละครก่อน';
 if((p.hp??0)<=0)return 'พักฟื้นก่อนเดินทาง';
 if(!nearTownService(p.mapId,p.x,'border-guide')||Math.abs(p.depth??0)>125||(p.height??0)>5)return 'คุยนายด่านในเมืองก่อน · เบี้ยผ่านแดน 25';
 if(region(city)?.services!=='town')return 'เลือกเมืองปลอดภัย';
 if(city===p.mapId)return 'คุณอยู่เมืองนี้แล้ว';
 if(city==='laplae-town'&&!p.journey?.laplaeOath)return 'ให้คำสัตย์ที่ช่องเขาเวียงศิลาก่อนเข้าลับแล';
 if(p.progression.bie<25)return 'เบี้ยไม่พอ · ต้องมี 25 เบี้ย';
 return undefined;
}
